var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 66C16.5 75.097 23.903 82.5 33 82.5C37.367 82.5 41.316 80.7675 44.2695 77.99L77.22 96.822C77.121 97.537 77 98.252 77 99C77 108.097 84.403 115.5 93.5 115.5C102.597 115.5 110 108.097 110 99C110 89.903 102.597 82.5 93.5 82.5C89.133 82.5 85.184 84.2325 82.2305 87.01L49.28 68.1835C49.379 67.463 49.5 66.748 49.5 66C49.5 65.252 49.379 64.537 49.28 63.8165L82.2305 44.99C85.184 47.7675 89.133 49.5 93.5 49.5C102.597 49.5 110 42.097 110 33C110 23.903 102.597 16.5 93.5 16.5C84.403 16.5 77 23.903 77 33C77 33.748 77.121 34.463 77.22 35.1835L44.2695 54.01C41.228 51.1207 37.195 49.5068 33 49.5C23.903 49.5 16.5 56.903 16.5 66Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon-share.0e861b1802a63bdf8bb93cb178bc85ec.svg";
export { ForwardRef as ReactComponent };